<template>
    <v-col cols="5" style="margin:2em">
        <h4>Presupuestos Pendientes</h4>
        <v-card style="padding: 1em">
            <v-simple-table v-if="budgets.length > 0" style="background-color: #fff !important;">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Nº Presupuesto</th>
                            <th class="text-left">Fecha</th>
                            <th class="text-left">Cantidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="budget in budgets" :key="budget.projectID">
                            <td>
                                <p style="margin-bottom:0px !important;font-weight: bold;" v-if="budget.projectID < 10"> 0000000{{ budget.projectID }}/{{
                                    budget.date_add.split("-")[0] }}
                                </p>
                                <p style="margin-bottom:0px !important;font-weight: bold;" v-if="budget.projectID < 100 && budget.projectID >= 10">
                                    000000{{ budget.projectID }}/{{ budget.date_add.split("-")[0] }}</p>
                                <p style="margin-bottom:0px !important;font-weight: bold;" v-if="budget.projectID < 1000 && budget.projectID >= 109">
                                    00000{{ budget.projectID }}/{{ budget.date_add.split("-")[0] }}</p>
                                {{ budget.fiscalName }}<br>
                                {{ budget.name }}
                            </td>
                            <td>{{ budget.date_add }}</td>
                            <td>{{ getParseTotal(budget.total_end) }}€</td>

                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <h3 v-else style="text-align: center">No hay presupuestos pendientes</h3>
        </v-card>
    </v-col>
</template>

<script>
export default {
    name: "pendingBudgets",
    props: ['budgets', 'refresh'],
    methods: {
        getParseTotal(total) {
            return parseFloat(total).toFixed(2)
        },
        acceptBudget(bid) {
            this.loaded = false;
            let url = this.base_url + '/api2/newAdmin/updatebudget';
            let formData = new FormData();
            formData.set('token', localStorage.token);
            formData.set('budgetID', bid);
            formData.set('status', 1);
            this.axios.post(url, formData).then(() => {
                this.refresh();
            });
        },
        deniedBudget(bid) {
            this.loaded = false;
            let url = this.base_url + '/api2/newAdmin/updatebudget';
            let formData = new FormData();
            formData.set('token', localStorage.token);
            formData.set('budgetID', bid);
            formData.set('status', 4);
            this.axios.post(url, formData).then(() => {
                this.refresh();
            });
        }
    }
}
</script>